import { PartnerTransferSection } from 'further-types/lp/partner-transfer';

export const PartnerTransferSectionLabels = {
  [PartnerTransferSection.Investments]: 'Investments',
  [PartnerTransferSection.Expenses]: 'Expenses',
  [PartnerTransferSection.Income]: 'Income',
  [PartnerTransferSection.Summary]: 'Summary',
};
